<template>
  <div class="flex flex-1 h-full">
    <Calendar
      ref="calendar"
      :loading="loading"
      :tasks="tasksWithRelationships"
      @update-calendar="fetchPeriod"
    />

    <portal v-if="task && task.contact" to="app-modal">
      <ContactModal :contact-id="task.contact" @hide="clearRouteQuery" @destroyed="fetchData" />
    </portal>

    <portal v-else-if="task && task.contactRequest" to="app-modal">
      <ContactRequestModal
        :contact-request-id="task.contactRequest"
        @hide="clearRouteQuery"
        @destroyed="fetchData"
      />
    </portal>

    <portal
      v-if="$route.query.editTaskId && task && !task.contact && !task.contactRequest"
      to="app-modal"
    >
      <TaskModal :task-id="$route.query.editTaskId" @task-modal:closed="taskModalClosed" />
    </portal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Calendar from '@/components/Calendar/Calendar.vue';
import ContactModal from '@/components/ContactModal/Index.vue';
import ContactRequestModal from '@/components/ContactRequests/ContactRequestModal.vue';
import TaskModal from '@/components/Tasks/TaskModal.vue';

export default {
  components: {
    Calendar,
    ContactModal,
    ContactRequestModal,
    TaskModal,
  },

  props: {
    accountId: { type: String, required: true },
  },

  data: () => ({
    loading: false,
    period: null,
  }),

  computed: {
    ...mapGetters('ui/accountTasks', ['tasks']),
    ...mapState('entities', {
      tasksWithRelationships({ contacts }) {
        return this.tasks.map((task) => {
          if (!task.contact) return task;

          if (typeof task.contact === 'string') {
            return { ...task, contact: contacts.byId[task.contact] };
          }

          return task;
        });
      },
    }),
    task() {
      if (!this.$route.query.editTaskId) {
        return undefined;
      }

      return this.$store.state.entities.tasks.byId[this.$route.query.editTaskId];
    },
  },

  methods: {
    ...mapActions('ui/accountTasks', {
      loadTasks: 'load',
    }),
    fetchPeriod({ period }) {
      this.period = period;
      this.fetchData();
    },
    async fetchData() {
      const { accountId } = this;

      const params = {
        per_page: 500,
        include: 'contact,contactRequest,orderItem,project.client,account',
        sort: 'due_at',
        filter: {
          due_between: this.period,
        },
      };

      this.loading = true;

      try {
        await this.loadTasks({
          accountId,
          params,
        });
      } catch (error) {
        //
      }

      this.loading = false;
    },
    clearRouteQuery() {
      const {
        name,
        params,
        query: { editContact, editContactRequest, editTaskId, ...restQuery },
      } = this.$route;

      if (!editContact && !editTaskId && !editContactRequest) return;

      this.$router.push({ name, params: { ...params }, query: { ...restQuery } });
    },
    taskModalClosed() {
      this.$router.push({
        name: this.$route.name,
        query: {
          taskId: this.$route.query.taskId,
        },
      });
    },
  },
};
</script>
